import { PostHogProvider } from 'posthog-js/react'
import { PropsWithChildren } from 'react'
import { postHogConfig } from '../postHogConfig'

export const PostHogProviderWrapper = ({ children }: PropsWithChildren) => {
	return (
		<PostHogProvider apiKey={postHogConfig.api_key} options={postHogConfig.options}>
			{children}
		</PostHogProvider>
	)
}
